import loadConsumerMailboxOptions from './loadConsumerMailboxOptions';
import { FromViewState, LoadAliasActionStatus } from 'owa-mail-compose-store';
import { getFromAddresses } from '../utils/getFromAddresses';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { action } from 'satcheljs/lib/legacy';

export default action('toggleFromContextMenu')(async function toggleFromContextMenu(
    viewState: FromViewState
) {
    viewState.isFromContextMenuShown = !viewState.isFromContextMenuShown;

    if (viewState.isFromContextMenuShown) {
        if (isConsumer() && viewState.loadAliasActionStatus == LoadAliasActionStatus.NotStarted) {
            viewState.loadAliasActionStatus = LoadAliasActionStatus.Started;
            await loadConsumerMailboxOptions();
            viewState.loadAliasActionStatus = LoadAliasActionStatus.Finished;
        }

        viewState.sendAsEmailAddresses = getFromAddresses();
    }
});
